// extracted by mini-css-extract-plugin
module.exports = {"property":"_26oFmY-"};